const actionTypeIdentifier = '3CB05862-12C4-4057-8015-9E96614936D2'

export const getOutputConfigRechargeItems = `GET-OUTPUT-CONFIG-RECHARGE-ITEMS-${actionTypeIdentifier}`;
export const setDefaultConfigRechargeItems = `SET-DEFAULT-CONFIG-RECHARGE-ITEMS-${actionTypeIdentifier}`;
export const setConfigRechargeItemsError = `SET-CONFIG-RECHARGE-ITEMS-ERROR-${actionTypeIdentifier}`;
export const setConfigRechargeItemsColSearchStr = `SET-CONFIG-RECHARGE-ITEMS-COLUMN-SEARCH-${actionTypeIdentifier}`;
export const sortConfigRechargeItemsItems = `SET-CONFIG-RECHARGE-ITEMS-ITEMS-${actionTypeIdentifier}`;
export const setConfigRechargeItemsPageSize = `SET-CONFIG-RECHARGE-ITEMS-PAGE-SIZE-${actionTypeIdentifier}`;